/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Wizard_Step5_EditInputs */



/**
* | output |
* | --- |
* | "Edit" |
*
* @param {Spaces_Wizard_Step5_EditInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_wizard_step5_edit = /** @type {((inputs?: Spaces_Wizard_Step5_EditInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Wizard_Step5_EditInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bearbeiten")
	return /** @type {LocalizedString} */ ("Edit")
});